import axios from "axios";

const fetchTerms = async (lang: string) => {
  return await axios.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${lang}/terms-and-conditions`
  );
};

export default fetchTerms;
